import React from "react";
import PropTypes from "prop-types";
import OptionWithDropdown from "./OptionWithDropdown";
import Option from "./Option";
import {
  Content,
  CreditCount,
  Credits,
  SidebarWrapper,
} from "./styles/sidebar-content-styles";
import "semantic-ui-css/components/icon.min.css";
import menuItemsType from "./types/menuItemsType";

const Sidebar = (props) => {
  const { engagementCredits, jobCredits, menuItems } = props;

  return (
    <SidebarWrapper id="sidebar">
      {/* Hiding Job Credits Until we decide what to do with them. */}
      {/* {typeof engagementCredits === "number" && (
        <Credits>
          <CreditCount className="sidebar-icon">
            {engagementCredits}
          </CreditCount>
          <Content className="content">engagement credits</Content>
        </Credits>
      )}
      {typeof jobCredits === "number" && (
        <Credits>
          <CreditCount className="sidebar-icon">{jobCredits}</CreditCount>
          <Content className="content">job credits</Content>
        </Credits>
      )} */}

      {menuItems.map((menuItem) => {
        const hasChildren = Object.prototype.hasOwnProperty.call(
          menuItem,
          "sublinks"
        );
        if (hasChildren) {
          return (
            <OptionWithDropdown key={menuItem.label} menuItem={menuItem} />
          );
        }
        return <Option key={menuItem.label} menuItem={menuItem} />;
      })}
    </SidebarWrapper>
  );
};

Sidebar.propTypes = {
  engagementCredits: PropTypes.number,
  jobCredits: PropTypes.number,
  menuItems: menuItemsType.isRequired,
};

Sidebar.defaultProps = {
  engagementCredits: PropTypes.isNull,
  jobCredits: PropTypes.isNull,
};

export default Sidebar;
